import videoDemoSubtitles from '@/assets/demo/video-subtitles-deepgram.json'

const SEEN_KEY_PREFIX = 'goodscriber:demo-lesson-seen:'

// 示范课结束后推荐的第一条素材，按听力等级挑；没定级的按 B1 推荐
const NEXT_LESSONS = {
  A: {
    categoryId: 'ListeningLessonsbyLevel',
    collectionId: 'A1',
    itemId: 'A1-001_-_Ten_Things_about_Me-5e6a5b46',
    title: 'Ten Things about Me',
    duration: '1:13',
    level: 'A1'
  },
  B1: {
    categoryId: 'bbc6minute',
    collectionId: 'yt-bbc-6-minute-english',
    itemId: 'yt-bbc-6-minute-english-7F1iJZr-p4E',
    title: 'Are you drinking enough water? · 6 Minute English',
    duration: '6:14',
    level: 'B1'
  },
  B2: {
    categoryId: 'youtube-vlog',
    collectionId: 'yt-sydney-serena',
    itemId: 'yt-sydney-serena-Pz68t3RGeqI',
    title: 'VLOG ★ a busy day in my life',
    duration: '10:43',
    level: 'B2'
  }
}

export function nextLessonAfterDemo(listeningLevel) {
  if (['A1', 'A2'].includes(listeningLevel)) return NEXT_LESSONS.A
  if (['B2', 'C1', 'C2'].includes(listeningLevel)) return NEXT_LESSONS.B2
  return NEXT_LESSONS.B1
}

// 示范素材的播放器参数：首页试用和新用户首次登录共用
export function demoLessonProps({ audioName, returnView }) {
  return {
    audioSrc: '',
    videoSrc: `${process.env.BASE_URL}assets/demo.mp4`,
    posterSrc: `${process.env.BASE_URL}assets/demo-poster.jpg`,
    audioName,
    originalSubtitles: videoDemoSubtitles.originalSubtitles,
    subtitles: videoDemoSubtitles.subtitles,
    practiceSubtitles: videoDemoSubtitles.practiceSubtitles,
    completeSubtitles: videoDemoSubtitles.completeSubtitles,
    demoTranslations: videoDemoSubtitles.translations,
    words: videoDemoSubtitles.words,
    useSmartSplit: false,
    originalText: videoDemoSubtitles.originalText,
    audioId: 'demo-video-speaking-fluently',
    materialId: '',
    materialBook: '',
    taskType: 'stt',
    duration: videoDemoSubtitles.duration,
    isDemo: true,
    returnView,
    returnParams: {}
  }
}

// 还没用过任何功能的账号：没消耗额度、没听过、没解锁素材、没上传过
function isUntouchedAccount(userData) {
  return !userData.quota?.used &&
    !userData.stats?.totalListeningSeconds &&
    !userData.stats?.totalFiles &&
    !userData.purchasedMaterials?.length
}

// 每个账号在一台设备上只自动带进示范一次
export function shouldStartWithDemoLesson(userData) {
  if (!isUntouchedAccount(userData)) return false
  const key = SEEN_KEY_PREFIX + userData.uid
  if (localStorage.getItem(key)) return false
  localStorage.setItem(key, '1')
  return true
}
